// src/services/terms.ts

/**
 * Service to handle Terms and Conditions related API calls
 */

import { API_BASE_URL } from "@/services/index";

/**
 * Mark Terms and Conditions as accepted for the current user
 */
export const acceptTermsAndConditions = async (token: string): Promise<void> => {
  console.log("[TermsService] Accepting Terms and Conditions...");
  
  try {
    const response = await fetch(`${API_BASE_URL}/access-requests/accept-terms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        terms_version: import.meta.env["VITE_TERMS_VERSION"]
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || "Failed to accept Terms and Conditions."
      );
    }

    const data = await response.json();
    console.log("[TermsService] Terms and Conditions accepted successfully:", data);
  } catch (error) {
    console.error("[TermsService] Error accepting terms:", error);
    throw error;
  }
};
